import { Component } from 'react';
import { ArrowsClockwise } from '@phosphor-icons/react';

export class LeaderboardErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[LeaderboardErrorBoundary]', error, info?.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#F4F6F5] flex items-center justify-center px-6" data-testid="leaderboard-error-boundary">
          <div className="text-center space-y-4">
            <p className="text-[#1D242B] font-semibold text-base">Couldn't load the leaderboard</p>
            <button
              onClick={this.handleRetry}
              data-testid="leaderboard-retry-btn"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#1B4332] text-white text-sm font-semibold rounded-xl"
            >
              <ArrowsClockwise className="w-4 h-4" weight="bold" />
              Tap to retry
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
